import React from 'react';
import { FaDatabase, FaLock, FaExclamationTriangle, FaDesktop, FaEnvelope, FaMobileAlt } from 'react-icons/fa';

const ItBreachMenu = ({ setStep }) => {
  const itBreachCategories = [
    {
      id: 'dataBreachForm',
      title: 'Data Event',
      description: 'Access to patient data or PHI that requires review',
      Icon: FaDatabase,
      iconColor: 'text-violet-600'
    },
    {
      id: 'ransomwareForm',
      title: 'Ransomware Event',
      description: 'Software that encrypts systems/data requiring attention',
      Icon: FaLock,
      iconColor: 'text-violet-600'
    },
    {
      id: 'cyberAttackForm',
      title: 'Cyber Event',
      description: 'Network activity, phishing, or malware requiring review',
      Icon: FaExclamationTriangle,
      iconColor: 'text-violet-600'
    },
    {
      id: 'systemBreachForm',
      title: 'System Event',
      description: 'Access to practice management systems requiring review',
      Icon: FaDesktop,
      iconColor: 'text-violet-600'
    },
    {
      id: 'emailBreachForm',
      title: 'Email Event',
      description: 'Email account activity or phishing requiring review',
      Icon: FaEnvelope,
      iconColor: 'text-violet-600'
    },
    {
      id: 'deviceBreachForm',
      title: 'Device Event',
      description: 'Device activity involving patient data requiring review',
      Icon: FaMobileAlt,
      iconColor: 'text-violet-600'
    }
  ];

  return (
    <div className="menu-screen">
      <h1 className="menu-heading">IT Security Event Report</h1>
      <p className="menu-sub">Select the category that best describes the security event</p>
      
      <div className="menu-grid three-cols">
        {itBreachCategories.map((category) => {
          const IconComponent = category.Icon;
          return (
            <div
              key={category.id}
              className="menu-card security"
              onClick={() => setStep(category.id)}
            >
              <div className="menu-icon" aria-hidden>
                <IconComponent className={`size-8 ${category.iconColor}`} />
              </div>
              <h3 className="menu-title">{category.title}</h3>
              <p className="menu-subtitle">{category.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ItBreachMenu;
